export default __webpack_public_path__ + "static/media/duthaya_logo.6396d45a.png";